// extracted by mini-css-extract-plugin
module.exports = {"gamification":"Gamification_gamification__1-P_x","contnet":"Gamification_contnet__1MXSU"};